import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BlogProvider } from './contexts/BlogContext';
import { OnlineClassProvider } from './contexts/OnlineClassContext';
import Header from './layout/Header';
import BlogPage from './pages/BlogPage';
import Footer from './layout/Footer';
import TrainingSimPage from './pages/TrainingSimPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import OrderBusinessChallenge from './pages/OrderBusinessChallenge';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import PurchaseCompleteIndividual from './pages/PurchaseCompleteIndividual';
import PurchaseCompleteGroup from './pages/PurchaseCompleteGroup';
import FacebookLandingPage from './pages/FacebookLandingPage';
import VBCLearningPath from './pages/VBCLearningPath';
import VBCOnline from './pages/VBCOnline';
import PaymentPage from './pages/PaymentPage';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import { usePageTracking } from './hooks/usePageTracking';
import { useConsentInitialization } from './hooks/useConsentInitialization';
import BusinessChallenge from './pages/BusinessChallenge';
import CookieConsentBanner from './components/CookieConsentBanner';

// Layout component for routes with header and footer
const MainLayout = ({ children }: { children: React.ReactNode }) => {
    usePageTracking(); // Add page tracking to layout
    useConsentInitialization(); // Initialize tracking based on consent

    return (
        <div className="relative min-h-screen flex flex-col">
            <Header />
            <main className="pt-16 flex-grow">{children}</main>
            <Footer />
            <CookieConsentBanner />
        </div>
    );
};

// Main App Component
function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BlogProvider>
                    <OnlineClassProvider>
                    <Router>
                        <Routes>
                            {/* Facebook landing page route - no header/footer */}
                            <Route path="/fb-landing" element={<FacebookLandingPage />} />
                            
                            {/* All other routes with header/footer */}
                            {/* <Route path="/home" element={<MainLayout><HomePage /></MainLayout>} /> */}
                            <Route path="/blog" element={<MainLayout><BlogPage /></MainLayout>} />
                            <Route path="/training" element={<MainLayout><TrainingSimPage /></MainLayout>} />
                            <Route path="/login" element={<MainLayout><LoginPage /></MainLayout>} />
                            <Route path="/vbc-learning-path" element={<MainLayout><VBCLearningPath /></MainLayout>} />
                            <Route path="/payment" element={<MainLayout><PaymentPage /></MainLayout>} />
                            <Route 
                                path="/admin" 
                                element={
                                    <MainLayout>
                                        <ProtectedRoute>
                                            <AdminPage />
                                        </ProtectedRoute>
                                    </MainLayout>
                                } 
                                
                            />
                            {/* <Route path="/test-api" element={<MainLayout><TestAPI /></MainLayout>} /> */}
                            <Route path="/business-challenge" element={<MainLayout><BusinessChallenge /></MainLayout>} />
                            <Route path="/orderBusinessChallenge" element={<MainLayout><OrderBusinessChallenge /></MainLayout>} />
                            <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
                            <Route path="/cookie-policy" element={<MainLayout><CookiePolicy /></MainLayout>} />
                            <Route path="/purchase_complete_individual" element={<MainLayout><PurchaseCompleteIndividual /></MainLayout>} />
                            <Route path="/purchase_complete_group" element={<MainLayout><PurchaseCompleteGroup /></MainLayout>} />
                            <Route path="/vbc-online" element={<MainLayout><VBCOnline /></MainLayout>} />
                            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
                            <Route path="/about-us" element={<MainLayout><AboutUs /></MainLayout>} />
                        </Routes>
                    </Router>
                    </OnlineClassProvider>
                </BlogProvider>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;